import { useState, useMemo } from 'react';
import './App.css';

const CATEGORIAS = {
  receita: [
    { id: 'salario',    label: 'Salário',       icone: '💼' },
    { id: 'freelance',  label: 'Freelance',      icone: '💻' },
    { id: 'outros_r',   label: 'Outros',         icone: '➕' },
  ],
  despesa: [
    { id: 'moradia',    label: 'Moradia',        icone: '🏠' },
    { id: 'alimentacao',label: 'Alimentação',    icone: '🍔' },
    { id: 'transporte', label: 'Transporte',     icone: '🚌' },
    { id: 'saude',      label: 'Saúde',          icone: '💊' },
    { id: 'lazer',      label: 'Lazer',          icone: '🎮' },
    { id: 'educacao',   label: 'Educação',       icone: '📚' },
    { id: 'outros_d',   label: 'Outros',         icone: '📦' },
  ],
};

const TODAS_CATS = [...CATEGORIAS.receita, ...CATEGORIAS.despesa];
const getCat = (id) => TODAS_CATS.find(c => c.id === id) || { label: id, icone: '•' };

const MESES = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];

const hoje = new Date();

const TRANSACOES_INICIAIS = [
  { id: 1, tipo: 'receita',  categoria: 'salario',     descricao: 'Salário Junho',   valor: 3200, data: '2025-06-05' },
  { id: 2, tipo: 'despesa',  categoria: 'moradia',     descricao: 'Aluguel',         valor: 900,  data: '2025-06-10' },
  { id: 3, tipo: 'despesa',  categoria: 'alimentacao', descricao: 'Supermercado',    valor: 380,  data: '2025-06-12' },
  { id: 4, tipo: 'despesa',  categoria: 'transporte',  descricao: 'Ônibus mensal',   valor: 160,  data: '2025-06-15' },
  { id: 5, tipo: 'receita',  categoria: 'freelance',   descricao: 'Projeto site',    valor: 800,  data: '2025-06-20' },
  { id: 6, tipo: 'despesa',  categoria: 'lazer',       descricao: 'Cinema + jantar', valor: 120,  data: '2025-06-22' },
  { id: 7, tipo: 'despesa',  categoria: 'saude',       descricao: 'Farmácia',        valor: 90,   data: '2025-06-25' },
];

let nextId = 8;
const fmt = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export default function App() {
  const [transacoes, setTransacoes] = useState(() => {
    try { return JSON.parse(localStorage.getItem('financas')) || TRANSACOES_INICIAIS; }
    catch { return TRANSACOES_INICIAIS; }
  });
  const [aba,       setAba]       = useState('dashboard');
  const [form,      setForm]      = useState({ tipo: 'despesa', categoria: 'alimentacao', descricao: '', valor: '', data: hoje.toISOString().split('T')[0] });
  const [filtroMes, setFiltroMes] = useState(`${hoje.getFullYear()}-${String(hoje.getMonth()+1).padStart(2,'0')}`);
  const [erro,      setErro]      = useState('');

  const salvar = (nova) => {
    localStorage.setItem('financas', JSON.stringify(nova));
    setTransacoes(nova);
  };

  const adicionar = () => {
    if (!form.descricao.trim()) { setErro('Informe uma descrição.'); return; }
    const v = parseFloat(form.valor);
    if (!v || v <= 0) { setErro('Valor inválido.'); return; }
    setErro('');
    salvar([...transacoes, { ...form, id: nextId++, valor: v }]);
    setForm(f => ({ ...f, descricao: '', valor: '' }));
  };

  const remover = (id) => salvar(transacoes.filter(t => t.id !== id));

  const transMes = useMemo(() =>
    transacoes.filter(t => t.data.startsWith(filtroMes)),
    [transacoes, filtroMes]
  );

  const totalReceitas = transMes.filter(t => t.tipo === 'receita').reduce((s, t) => s + t.valor, 0);
  const totalDespesas = transMes.filter(t => t.tipo === 'despesa').reduce((s, t) => s + t.valor, 0);
  const saldo = totalReceitas - totalDespesas;

  // Gastos por categoria
  const porCategoria = useMemo(() => {
    const map = {};
    transMes.filter(t => t.tipo === 'despesa').forEach(t => {
      map[t.categoria] = (map[t.categoria] || 0) + t.valor;
    });
    return Object.entries(map).sort((a, b) => b[1] - a[1]);
  }, [transMes]);

  const maxCat = porCategoria[0]?.[1] || 1;

  // Meses disponíveis
  const mesesDisp = useMemo(() => {
    const set = new Set(transacoes.map(t => t.data.slice(0, 7)));
    return [...set].sort().reverse();
  }, [transacoes]);

  const [mesAno] = filtroMes.split('-');
  const nomeMes = `${MESES[parseInt(filtroMes.split('-')[1]) - 1]} ${filtroMes.split('-')[0]}`;

  return (
    <div className="app">
      <header>
        <h1>💰 Finanças Pessoais</h1>
        <nav>
          {['dashboard','transacoes','adicionar'].map(a => (
            <button key={a} className={aba === a ? 'ativo' : ''} onClick={() => setAba(a)}>
              {{ dashboard: '📊 Dashboard', transacoes: '📋 Histórico', adicionar: '➕ Adicionar' }[a]}
            </button>
          ))}
        </nav>
      </header>

      <main>
        {/* ── FILTRO MES ── */}
        <div className="filtro-mes">
          <select value={filtroMes} onChange={e => setFiltroMes(e.target.value)}>
            {mesesDisp.map(m => {
              const [y, mo] = m.split('-');
              return <option key={m} value={m}>{MESES[parseInt(mo)-1]} {y}</option>;
            })}
          </select>
        </div>

        {/* ── DASHBOARD ── */}
        {aba === 'dashboard' && (
          <div className="dashboard">
            <div className="kpis">
              <div className="kpi receita">
                <span className="kpi-label">Receitas</span>
                <span className="kpi-valor">{fmt(totalReceitas)}</span>
              </div>
              <div className={`kpi saldo ${saldo >= 0 ? 'positivo' : 'negativo'}`}>
                <span className="kpi-label">Saldo</span>
                <span className="kpi-valor">{fmt(saldo)}</span>
              </div>
              <div className="kpi despesa">
                <span className="kpi-label">Despesas</span>
                <span className="kpi-valor">{fmt(totalDespesas)}</span>
              </div>
            </div>

            {totalDespesas > 0 && (
              <div className="card-section">
                <h3>Gastos por categoria — {nomeMes}</h3>
                <div className="cats-lista">
                  {porCategoria.map(([catId, valor]) => {
                    const cat = getCat(catId);
                    const pct = Math.round((valor / totalDespesas) * 100);
                    return (
                      <div key={catId} className="cat-row">
                        <span className="cat-icone">{cat.icone}</span>
                        <span className="cat-label">{cat.label}</span>
                        <div className="cat-barra-wrap">
                          <div className="cat-barra" style={{ width: `${(valor/maxCat)*100}%` }}/>
                        </div>
                        <span className="cat-pct">{pct}%</span>
                        <span className="cat-valor">{fmt(valor)}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {transMes.length === 0 && (
              <p className="vazio">Nenhuma transação em {nomeMes}.</p>
            )}
          </div>
        )}

        {/* ── HISTÓRICO ── */}
        {aba === 'transacoes' && (
          <div className="historico">
            {transMes.length === 0
              ? <p className="vazio">Nenhuma transação em {nomeMes}.</p>
              : transMes.sort((a,b) => b.data.localeCompare(a.data)).map(t => {
                  const cat = getCat(t.categoria);
                  return (
                    <div key={t.id} className={`transacao ${t.tipo}`}>
                      <span className="trans-icone">{cat.icone}</span>
                      <div className="trans-info">
                        <span className="trans-desc">{t.descricao}</span>
                        <span className="trans-meta">{cat.label} · {t.data.split('-').reverse().join('/')}</span>
                      </div>
                      <span className={`trans-valor ${t.tipo}`}>
                        {t.tipo === 'receita' ? '+' : '-'}{fmt(t.valor)}
                      </span>
                      <button className="btn-del" onClick={() => remover(t.id)}>✕</button>
                    </div>
                  );
                })
            }
          </div>
        )}

        {/* ── ADICIONAR ── */}
        {aba === 'adicionar' && (
          <div className="form-card">
            <h3>Nova transação</h3>
            <div className="tipo-toggle">
              {['despesa','receita'].map(tp => (
                <button key={tp} className={form.tipo === tp ? 'ativo' : ''}
                  onClick={() => setForm(f => ({ ...f, tipo: tp, categoria: tp === 'despesa' ? 'alimentacao' : 'salario' }))}>
                  {tp === 'despesa' ? '📤 Despesa' : '📥 Receita'}
                </button>
              ))}
            </div>
            <label>Categoria
              <select value={form.categoria} onChange={e => setForm(f => ({ ...f, categoria: e.target.value }))}>
                {CATEGORIAS[form.tipo].map(c => <option key={c.id} value={c.id}>{c.icone} {c.label}</option>)}
              </select>
            </label>
            <label>Descrição
              <input value={form.descricao} onChange={e => setForm(f => ({ ...f, descricao: e.target.value }))} placeholder="Ex: Supermercado Extra"/>
            </label>
            <div className="form-row">
              <label>Valor (R$)
                <input type="number" value={form.valor} onChange={e => setForm(f => ({ ...f, valor: e.target.value }))} placeholder="0,00" min="0" step="0.01"/>
              </label>
              <label>Data
                <input type="date" value={form.data} onChange={e => setForm(f => ({ ...f, data: e.target.value }))}/>
              </label>
            </div>
            {erro && <p className="erro">{erro}</p>}
            <button className={`btn-adicionar ${form.tipo}`} onClick={adicionar}>Adicionar {form.tipo}</button>
          </div>
        )}
      </main>
    </div>
  );
}
